<template>
    <FormControl
        :label="customField.title"
        :error="errors.getValidationErrorUsingRawString(customField.id.value)"
    >
        <template
            v-if="
                typeof savedValue.response === 'string' ||
                savedValue.response === null
            "
        >
            <input
                type="hidden"
                :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CUSTOM_FIELD_ID_KEY}]`"
                :value="customField.id.value"
            />
            <input
                type="hidden"
                :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CONTENT_KEY}]`"
                value="0"
            />
            <CheckboxInput
                label=""
                :useBookingFormThemeCssVariables="true"
                :required="customField.isRequired"
                :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CONTENT_KEY}]`"
                :checked="!!savedValue.response && savedValue.response !== '0'"
                value="1"
            >
                <span>
                    {{ localSettings.data.singleCheckboxLabel }}
                </span>
                <span
                    v-if="customField.isRequired"
                    class="text-red-500 text-lg"
                >
                    *
                </span>
            </CheckboxInput>
        </template>
        <template v-else>
            <UnexpectedError />
        </template>
    </FormControl>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import CheckboxInput from '@/Shared/Component/Forms/CheckboxInput.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import {
        RAW_RESPONSE_CONTENT_KEY,
        RAW_RESPONSE_CUSTOM_FIELD_ID_KEY,
        type CustomFieldResponseDTO,
        type CustomFieldSettingsSingleCheckboxType,
    } from '@/Shared/AutoGenerated/Main'
    import UnexpectedError from '@/BookingForm/BookingForm/Component/CustomField/UnexpectedError.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField>,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
        savedValue: {
            type: Object as PropType<CustomFieldResponseDTO>,
            required: true,
        },
    })

    const localSettings: CustomFieldSettingsSingleCheckboxType =
        props.customField.settings
</script>
